import s from '../s';
import {GRAD_YEAR_INVALID_MSG, GRAD_YEAR_REQUIRED_MSG, isPlausibleGradYear} from '../components/grad-year/grad-year-util';

// The graduation year, shared by both product page layouts. Moved unchanged from components/grad-year/grad-year.tsx. The year is
// for reference only (never printed); it reaches the order as GradYear. Add To Cart reads ui.grad_year_input and ps.grad_year.

/** Keeps the digits (at most 4); a plausible year becomes ps.grad_year. Returns the digits for the input. */
export const setGradYearInput = (value: string): string => {
    const digits = value.replace(/\D/g, '').slice(0, 4);
    s.ui.grad_year_input = digits;
    s.ps.grad_year = isPlausibleGradYear(digits) ? digits : '';

    if (s.ps.atc_error === GRAD_YEAR_REQUIRED_MSG || s.ps.atc_error === GRAD_YEAR_INVALID_MSG) {
        s.ps.atc_error = '';
    }
    return digits;
};

/** The input starts from the state's year (a restored cart line). */
export const initGradYearInput = (): void => {
    s.ui.grad_year_input = s.ps.grad_year ?? '';
};

/** product.tsx's mount rule for the graduation year. */
export const gradYearMounted = (): boolean => !s.IsPortal3 && s.ui.show_grad_year;
